import { Modal, notification } from 'antd';

export interface GlobalVariables {
  permissions: unknown;
  userID: string | number | null;
  examCord: string | null;
  username: string | null;
  nickName?: string | null;
  avatar?: string | null;
  isAdmin?: boolean | null;
  logout: unknown;
  curMenu: unknown;
  alertErrorTime: number;
  deploymentSlug: string;
  forceDeploymentSlug: string | null;
  baseURL: string | null;
}

const globalVars: GlobalVariables = {
  permissions: null,
  userID: null,
  examCord: null,
  username: null,
  logout: null,
  curMenu: null,
  alertErrorTime: 0,
  deploymentSlug: window.location.host,
  forceDeploymentSlug: null,
  baseURL: null,
};

window.alert = (message?: unknown): void => {
  notification.info({
    message: '提示',
    description: message as React.ReactNode,
  });
};

window.alertError = (message: unknown): void => {
  notification.destroy();
  notification.error({
    message: '错误',
    description: message as React.ReactNode,
  });
};

window.confirmAsync = (message, actionLabel, context, callback): void => {
  Modal.confirm({
    title: '确认',
    content: message,
    okText: actionLabel,
    onOk() {
      callback.call(context);
    },
  });
};

window.confirmQ = (message, actionLabel): Promise<boolean> =>
  new Promise((resolve) => {
    Modal.confirm({
      title: '确认',
      content: message,
      okText: actionLabel,
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
    });
  });

export interface TimerReference {
  timerID: ReturnType<typeof setTimeout> | null;
}

export function debounce<Arguments extends unknown[]>(
  func: (...args: Arguments) => void,
  wait: number,
  immediate?: boolean,
  parentTimer?: TimerReference,
): (...args: Arguments) => void {
  let timerID: ReturnType<typeof setTimeout> | null = null;

  return function debounced(this: unknown, ...args: Arguments): void {
    const later = (): void => {
      timerID = null;
      if (parentTimer) parentTimer.timerID = null;
      if (!immediate) func.apply(this, args);
    };
    const callNow = Boolean(immediate && !timerID);
    if (timerID) clearTimeout(timerID);
    timerID = setTimeout(later, wait);
    if (parentTimer) parentTimer.timerID = timerID;
    if (callNow) func.apply(this, args);
  };
}

window.debounce = debounce;

export default globalVars;
